<template>
  <div class="vertical-list-cards-container">
    <div class="bg-white br2">
      <h1 class="section-border ma0 pa0 f5 ttu fw5 pa3">Интерфейс</h1>
      <div class="pa3">
        <h1 class="ma0 pa0 f5 fw5">Показывать пункты меню</h1>
        <menu-tree :tree="allChildren(root.code)" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuTree from '@/components/settings/MenuTree.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    MenuTree
  },
  computed: {
    ...mapGetters('settings/menu', ['root', 'allChildren'])
  }
}
</script>

<style lang="scss" scoped>
.section-border {
  border-bottom-style: solid;
  border-bottom-width: .1rem;
  border-color: #BCCCDC;
}
</style>
